import { render, staticRenderFns } from "./importMaterial.vue?vue&type=template&id=5359ec12"
import script from "./importMaterial.vue?vue&type=script&lang=js"
export * from "./importMaterial.vue?vue&type=script&lang=js"
import style0 from "./importMaterial.vue?vue&type=style&index=0&id=5359ec12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports